"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};
export type HomeSeventeenHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLButtonElement>;
    /** Default: "Toggle Menu" */
    headerDiv0Nav0Div0Link0LinkAriaLabel?: string;
    /** Default: "#" */
    headerDiv0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    headerDiv0Nav0Div0Link0LinkId?: string;
    headerDiv0Nav0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "route.home" */
    headerDiv0Nav0Div0Link1LinkHref?: string;
    headerDiv0Nav0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-17.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "close" */
    headerDiv0Nav0Div1Div0Button0ButtonAriaLabel?: string;
    /** Default: "menu_close" */
    headerDiv0Nav0Div1Div0Button0ButtonId?: string;
    headerDiv0Nav0Div1Div0Button0ButtonVisible?: boolean;
    headerDiv0Nav0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "route.home" */
    headerDiv0Nav0Div1Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-17.svg" */
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "route.login" */
    headerDiv0Nav0Div1Div1Div0Link0LinkHref?: string;
    /** Default: "Sign In" */
    headerDiv0Nav0Div1Div1Div0Link0LinkText?: ReactNode;
    headerDiv0Nav0Div1Div1Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "route.register" */
    headerDiv0Nav0Div1Div1Div0Link1LinkHref?: string;
    /** Default: "Sign Up" */
    headerDiv0Nav0Div1Div1Div0Link1LinkText?: ReactNode;
    headerDiv0Nav0Div1Div1Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "route.booking" */
    headerDiv0Nav0Ul0Li0Link0LinkHref?: string;
    headerDiv0Nav0Ul0Li0Link0LinkVisible?: boolean;
    headerDiv0Nav0Ul0Li0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Ul0Li0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Schedule Consultation" */
    headerDiv0Nav0Ul0Li0Link0Span1SpanText?: ReactNode;
    headerSectionCircles: HeaderSectionCirclesItem[];
    headerSectionCirclesItemWrapper?: (item: HeaderSectionCirclesItem, content: ReactNode) => ReactNode;
    headerSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSeventeenHeaderSectionGenerated: FC<HomeSeventeenHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    headerDiv0Nav0Div0Link0LinkAriaLabel = "Toggle Menu",
    headerDiv0Nav0Div0Link0LinkHref = "#",
    headerDiv0Nav0Div0Link0LinkId = "mobile_btn",
    headerDiv0Nav0Div0Link0LinkVisible,
    headerDiv0Nav0Div0Link0LinkRenderer,
    headerDiv0Nav0Div0Link0LinkProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-17.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div0Link1LinkHref = "route.home",
    headerDiv0Nav0Div0Link1LinkVisible,
    headerDiv0Nav0Div0Link1LinkRenderer,
    headerDiv0Nav0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Button0ButtonAriaLabel = "close",
    headerDiv0Nav0Div1Div0Button0ButtonId = "menu_close",
    headerDiv0Nav0Div1Div0Button0ButtonVisible,
    headerDiv0Nav0Div1Div0Button0ButtonRenderer,
    headerDiv0Nav0Div1Div0Button0ButtonProps,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-17.svg",
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div1Div0Link0LinkHref = "route.home",
    headerDiv0Nav0Div1Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Link0LinkProps,
    headerDiv0Nav0Div1Div1Div0Link0LinkHref = "route.login",
    headerDiv0Nav0Div1Div1Div0Link0LinkText = "Sign In",
    headerDiv0Nav0Div1Div1Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div1Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div1Div0Link0LinkProps,
    headerDiv0Nav0Div1Div1Div0Link1LinkHref = "route.register",
    headerDiv0Nav0Div1Div1Div0Link1LinkText = "Sign Up",
    headerDiv0Nav0Div1Div1Div0Link1LinkVisible,
    headerDiv0Nav0Div1Div1Div0Link1LinkRenderer,
    headerDiv0Nav0Div1Div1Div0Link1LinkProps,
    headerDiv0Nav0Ul0Li0Link0LinkHref = "route.booking",
    headerDiv0Nav0Ul0Li0Link0LinkVisible,
    headerDiv0Nav0Ul0Li0Link0LinkRenderer,
    headerDiv0Nav0Ul0Li0Link0LinkProps,
    headerDiv0Nav0Ul0Li0Link0Span1SpanText = "Schedule Consultation",
    headerSectionCircles,
    headerSectionCirclesItemWrapper,
    headerSectionCirclesRenderer,
}) => {
    return (
        <header className={isScrolled ? "header header-seventeen fixed" : "header header-seventeen"}>
            <div className="container">
                <nav className="navbar navbar-expand-lg header-nav">
                    <div className="navbar-header">
                        {renderNode(headerDiv0Nav0Div0Link0LinkVisible, headerDiv0Nav0Div0Link0LinkRenderer, (
                            <SmartLink id={headerDiv0Nav0Div0Link0LinkId} href={headerDiv0Nav0Div0Link0LinkHref} aria-label={headerDiv0Nav0Div0Link0LinkAriaLabel} onClick={onMobileBtn} {...(headerDiv0Nav0Div0Link0LinkProps ?? {})}>
                                <i className="fa-solid fa-bars" />
                            </SmartLink>
                        ))}
                        {renderNode(headerDiv0Nav0Div0Link1LinkVisible, headerDiv0Nav0Div0Link1LinkRenderer, (
                            <SmartLink href={headerDiv0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(headerDiv0Nav0Div0Link1LinkProps ?? {})}>
                                {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid normal-logo" alt={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </SmartLink>
                        ))}
                    </div>
                    <div className="main-menu-wrapper">
                        <div className="menu-header">
                            {renderNode(headerDiv0Nav0Div1Div0Link0LinkVisible, headerDiv0Nav0Div1Div0Link0LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(headerDiv0Nav0Div1Div0Link0LinkProps ?? {})}>
                                    {renderNode(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                            {renderNode(headerDiv0Nav0Div1Div0Button0ButtonVisible, headerDiv0Nav0Div1Div0Button0ButtonRenderer, (
                                <button type="button" id={headerDiv0Nav0Div1Div0Button0ButtonId} className="menu-close" aria-label={headerDiv0Nav0Div1Div0Button0ButtonAriaLabel} onClick={onMenuClose} {...(headerDiv0Nav0Div1Div0Button0ButtonProps ?? {})}>
                                    <i className="fas fa-times" />
                                </button>
                            ))}
                        </div>
                        <HeaderNav menus={menus} />
                        <div className="header-items">
                            <div className="header-items-button">
                                {renderNode(headerDiv0Nav0Div1Div1Div0Link0LinkVisible, headerDiv0Nav0Div1Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={headerDiv0Nav0Div1Div1Div0Link0LinkHref} className="btn btn-primary" {...(headerDiv0Nav0Div1Div1Div0Link0LinkProps ?? {})}>
                                        <i className="isax isax-lock-1 me-2" />
                                        {headerDiv0Nav0Div1Div1Div0Link0LinkText}
                                    </SmartLink>
                                ))}
                                {renderNode(headerDiv0Nav0Div1Div1Div0Link1LinkVisible, headerDiv0Nav0Div1Div1Div0Link1LinkRenderer, (
                                    <SmartLink href={headerDiv0Nav0Div1Div1Div0Link1LinkHref} className="btn btn-secondary" {...(headerDiv0Nav0Div1Div1Div0Link1LinkProps ?? {})}>
                                        <i className="isax isax-user-tick4 me-2" />
                                        {headerDiv0Nav0Div1Div1Div0Link1LinkText}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                    <ul className="nav header-navbar-rht">
                        <li>
                            {renderNode(headerDiv0Nav0Ul0Li0Link0LinkVisible, headerDiv0Nav0Ul0Li0Link0LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Ul0Li0Link0LinkHref} className="theme-17-btn" {...(headerDiv0Nav0Ul0Li0Link0LinkProps ?? {})}>
                                    <span className="icon">
                                        <i className="isax isax-calendar5" />
                                    </span>
                                    <span className="text">{headerDiv0Nav0Ul0Li0Link0Span1SpanText}</span>
                                    <div className="container-stars">
                                        <div className="stars" />
                                    </div>
                                    <div className="glow">
                                        {renderCollectionNode(
                                            headerSectionCircles,
                                            (item: HeaderSectionCirclesItem) => (
                                                <div className={item.className ?? "circle"} key={item.key} />
                                            ),
                                            headerSectionCirclesItemWrapper,
                                            headerSectionCirclesRenderer
                                        )}
                                    </div>
                                </SmartLink>
                            ))}
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default HomeSeventeenHeaderSectionGenerated;
